//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { AbstractProjectModel } from "@app/catalog-common";
import { PresenterRegistration, PresenterType } from "@app/shared";

@PresenterRegistration(
{
    types: [AbstractProjectModel]
})
@Component({
    selector: 'project-presenter',
    template: '<project-item [id]="data().id" [project]="data()" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectPresenterComponent {
    public data: WritableSignal<AbstractProjectModel>;
    
    constructor() {
        this.data = signal<AbstractProjectModel>(null);
    }
}